export const paymentTypeParam = 'paymentType';
